
import styles from './preLoginLayout.module.scss';

const PreLoginLayout = ({ children }) => (
  <div className={styles.container}>{children}</div>
);

export default PreLoginLayout;
